import { isIdColumnName } from '../builder/utils';
export const adminRoleName = 'admin';
export const validateRole = (role) => {
    if (role === adminRoleName) {
        throw new Error(`Role ${role} is reserved. Admin role is automatically created and has all permissions. You can't modify it.`);
    }
};
export const buildOperations = ({ entity, accessTypes, fieldNames, predicate, }) => {
    let operations = {};
    for (const accessType of accessTypes) {
        if (accessType === 'delete') {
            operations = {
                ...operations,
                delete: predicate,
            };
        }
        else {
            const entityFieldNames = fieldNames?.length ? fieldNames : Object.values(entity.fields).map(field => field.name);
            operations = {
                ...operations,
                [accessType]: {
                    ...operations[accessType],
                    ...Object.fromEntries(entityFieldNames.filter(fieldName => !isIdColumnName(fieldName)).map(fieldName => [fieldName, predicate])),
                },
            };
        }
    }
    return operations;
};
//# sourceMappingURL=acl.js.map